import React, {useState} from 'react';
import { useAuth } from "../../../context/auth";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: "center",
        marginTop: 10,
        marginBottom: 10
    },
    table: {
        borderCollapse: 'collapse',
        width: '80%',
        marginTop: 20
    },
    th: {
        border: '1px solid #ddd',
        padding: 8,
        background: '#f2f2f2'
    },
    td: {
        border: '1px solid #ddd',
        padding: 8
    }
}));


function DQCRTool_CreationJobsPage() {
    const classes = useStyles();
    const { authUser } = useAuth();

    // const [targetAudience, setTargetAudience] = useState(TARGET_AUDIENCE);

    return (
        <div className={classes.container}>
            <h3>Landed on Creation Jobs Page</h3>
            <br />

        </div>
    );
}

export default DQCRTool_CreationJobsPage;





